import I18nHelper from "@helpers/I18nHelper";
import { isDev } from "@helpers/utils";
import useLanguageStore from "@store/language.store";
import useLanguageSwitcherStore from "@store/languageSwitcher.store";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router";
import { DevTools } from "./devtools/DevTools";

export type breakpoints = "xs" | "sm" | "md" | "lg" | "xl";

function App() {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  const { setLanguage, language } = useLanguageStore();
  const { clearSlugs } = useLanguageSwitcherStore();

  useEffect(() => {
    // Clear slugs on route change
    clearSlugs();

    // Sync language from path
    const langFromRoute = I18nHelper.getLangFromPath(pathname);

    if (i18n.language !== langFromRoute || language !== langFromRoute) {
      setLanguage(langFromRoute);
      i18n.changeLanguage(langFromRoute);
    }
  }, [pathname, i18n.language, i18n.changeLanguage, setLanguage, language]);

  return (
    <>
      <Outlet />
      {isDev() && <DevTools />}
    </>
  );
}

export default App;
